// Server-side exports — use in edge functions
// import { defineQuery, defineMutation, serve } from '@fliisi/trellis'

export { defineQuery, defineMutation } from "./define.ts";
export { serve } from "./serve.ts";
export { initSentry, captureException, flush as flushSentry } from "./sentry.ts";
export type { Api } from "./registry.ts";
export { createApiClient, TrellisError } from "./client.ts";
export type {
	QueryRoute,
	MutationRoute,
	AnyRoute,
	HandlerParams,
	AuthContext,
	ApiRegistry,
	ApiResponse,
	SuccessResponse,
	ErrorResponse,
	InferInput,
	InferOutput,
} from "./types.ts";
